import { ArrowCircleRight, ArrowRight, ChatDots } from '@phosphor-icons/react';
import { ActionType } from '../utils/types.ts';

type CTAIconProps = {
  actionType: ActionType;
};

export const CTAIcon = ({ actionType }: CTAIconProps) => {
  if (actionType === ActionType.QUESTION) return <ChatDots size={18} />;
  if (actionType === ActionType.REDIRECT) return <ArrowRight size={18} />;

  return <ArrowCircleRight size={18} />;
};
